const roles = (roles = [], action) => {
  switch (action.type) {
    case 'FETCH_ROLES':
      return action.payload
    default:
      return roles
  }
}
export default roles
